<template>
  <BaseListHeader>
    <div class="flex -mx-3">
      <div class="flex-1 px-3">Name</div>
      <div class="w-24 px-3 text-right">Status</div>
      <div class="w-48 px-3 text-right">Subscribed</div>
    </div>
  </BaseListHeader>
</template>

<script>
export default {
  name: 'ListHeader',
};
</script>
